module.exports = __webpack_public_path__ + "static/media/simple-icon.ed5981d0.svg";